function vouchers() {
	const elId = '#app-appmessages';
	const elClass = '.js-vue-appmessages';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const headerHandicap = 1;

	const app = new Vue({
		el: elId,
		data: {
			search: {
				field: null,
				currentkeyword: null
			},
			results: {
				found: 0,
				count: 0,
				items: [],
				fullitems: [],
				selected: null,
				deactivate: null
			},
			download: {
				username: null,
				password: null,
				result: null
			},
			pagination: {
				max: 999,
				pagesize: 10,
				currentpage: 0
			},
			settings: {
				showAll: false
			},
			error: null,
			modal: null
		},
		created: function() {
			this.fetchData();
		},
		mounted: function() {
			$(elClass).removeClass('is-mounting');
		},
		methods: {
			fetchData: function() {
				const self = this;
				GET('/baas/nominow_appmessage/appnotificationbatch')
					.then(xhr => {
						self.error = null;
						const response = JSON.parse(xhr.responseText);
						const vouchers = Array.prototype.map.call(response, el => {
							const css = 'is-faded';
							const extra = {};
							for (const attrname in el) {
								extra[attrname] = el[attrname];
							}
							extra.CreatedDate = el.IsActive == 'Yes' ? window.formatDate(el.CreatedDate) : `<span class='${css}'>${window.formatDate(el.CreatedDate)}</span>`;
							return extra;
						});
						// show only first columns
						vouchers.splice(0, 0, {
							Name: 200,
							CreatedDate: 150
						});
						self.results.fullitems = vouchers;
						self.results.items = vouchers;
						self.results.count = vouchers.length - headerHandicap;
						$(elClass).removeClass('is-creating');
					})
					.catch(xhr => {
						self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
						$(elClass).removeClass('is-creating');
					});
			},
			doSearch: function() {
				const self = this;
				/* in this case, we're searching the existing list instead of making a get call, so there's no loading going on in this search function */
				if (isLoading() || self.search.field == null) {
					return;
				}
				self.search.currentkeyword = self.search.field;
				const search = this.search.currentkeyword.toLowerCase();
				if (!search) {
					self.results.items = self.results.fullitems;
					self.results.found = 0;
					self.search.currentkeyword = null;
				} else {
					const newQueue = [];
					/* header */
					newQueue.push(self.results.fullitems[0]);

					for (let i = 1; i < self.results.fullitems.length; i++) {
						const q = self.results.fullitems[i];
						const arr = Array.prototype.map.call(Object.keys(q), a => q[a]);
						let txt = Array.prototype.join.call(arr, ' ');
						txt = txt.toLowerCase();
						if (txt.indexOf(search) > -1) {
							newQueue.push(q);
						}
					}
					self.results.items = newQueue;
					self.results.found = newQueue.length - headerHandicap;
				}
				self.pagination.currentpage = 0;
			},
			getFormattedDate: function(str) {
				// first remove any possible html, since the expirydate is wrapped in a span
				if (str == null) return null;
				str = str.replace("<span class='is-faded'>", '');
				str = str.replace('</span>', '');
				return window.formatDate(str);
			},
			selectItem: function(item, ix) {
				const self = this;
				this.results.selected = item;
				toggleLoader(false);
			},
			showDeactivateModal: function(item) {
				const self = this;
				this.download.username = null;
				this.download.password = null;
				if (item.IsActive == 'Yes') {
					this.results.deactivate = item;
				}
				toggleLoader(false);
			},
			cancelQueueItem: function() {
				const self = this;

				const payload = {
					ArticleId: self.results.selected.ArticleId
				};
				PUT('/baas/nominow_appmessage/appnotificationbatch', payload).then(
					xhr => {
						self.fetchData();
						self.results.selected = null;
						self.results.deactivate = null;
						window.initToast('Notification deactivated', 'success');
					},
					xhr => {
						self.results.selected = null;
						self.results.deactivate = null;
						window.initToast('Notification deactivated failed', 'error');
					}
				);
			},
			closemodals: function() {
				this.results.selected = null;
				this.modal = null;
			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
vouchers();
